import React from 'react';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import './Toast.css';

const Fade = cssTransition({
  enter: 'fadeInDown',
  exit: 'fadeInUp',
  duration: 1000,
});

export const showToast = toast;

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return 'fas fa-check-circle';
    case 'error':
      return 'fas fa-exclamation-circle';
    default:
      return '';
  }
};

export const ToastBody = ({ icon, title, subtitle }) => {
  const iconClass = getIcon(icon);
  return (
    <div className="toast-body">
      {icon && <i className={`icon ${iconClass}`} />}
      <div className={`content ${subtitle ? 'rows' : 'row'}`}>
        <h3>{title}</h3>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
  );
};

const CloseButton = ({ closeToast }) => (
  <button type="button" className="close-button" onClick={closeToast}>
    <i className="fal fa-times" />
  </button>
);

export const Toast = ({ ...rest }) => (
  <ToastContainer
    position="top-center"
    autoClose={6000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss={false}
    draggable={false}
    pauseOnHover={false}
    transition={Fade}
    closeButton={CloseButton}
    {...rest}
  />
);

export const showSuccessToast = (title, subtitle) => {
  showToast.success(
    <ToastBody icon="success" title={title} subtitle={subtitle} />,
  );
};
